export default __webpack_public_path__ + "static/media/badge.665a1202.png";